import { render } from "./communicationPref.vue?vue&type=template&id=b9372a90&scoped=true&ts=true"
import script from "./communicationPref.vue?vue&type=script&lang=ts"
export * from "./communicationPref.vue?vue&type=script&lang=ts"

import "./communicationPref.vue?vue&type=style&index=0&id=b9372a90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9372a90"]])

export default __exports__